import Open from './Open/Open';
import InsertDeleteRow from './InsertDeleteRow/InsertDeleteRow';
import InsertDeleteColumn from './InsertDeleteColumn/InsertDeleteColumn';
import Copy from './Copy/Copy';
import Paste from './Paste/Paste';
import CreatePivot from './CreatePivot/CreatePivot';
import ExportCsv from './ExportCSV/ExportCsv';
import WriteCell from './WriteCell/WriteCell';
import WriteRange from './WriteRange/WriteRange';
import VLookUp from './VLookUp/VLookUp';
import ReadSheet from './ReadSheet/ReadSheet';
import Save from './Save/Save';
import SetCellFormula from './SetCellFormula/SetCellFormula';
import RunMacro from './RunMacro/RunMacro';
import { types } from './types';

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Actions(action, showAlert, variables, setOpenVariable) {
    console.log("types--->", types.WRITERANGE)

    switch (action.actionName) {
        case types.OPEN:
            return <Open action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.INSDELROW:
            return <InsertDeleteRow action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.INSDELCOL:
            return <InsertDeleteColumn action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.COPY:
            return <Copy action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.PASTE:
            return <Paste action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.PIVOT:
            return <CreatePivot action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.EXPORTCSV:
            return <ExportCsv action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.WRITECELL:
            return <WriteCell action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.VLOOKUP:
            return <VLookUp action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.READSHEET:
            return <ReadSheet action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.SAVE:
            return <Save action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.SETCELLFORMULA:
            return <SetCellFormula action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.RUNMACRO:
            return <RunMacro action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.WRITERANGE:
            return <WriteRange action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        default:
            break;
    }
}

export default Actions;
